import {ChapterFiltersDTO} from "@/models/filters/ChapterFiltersDTO";
import {FILTERS_ARGS, LICENSE_TYPES_OPTIONS, TENANT_OPTIONS} from "@/app/exercise/modules/trainings/core/training-const";

export class ChapterFiltersModel {
  constructor(filters) {
    this.filters = new ChapterFiltersDTO(filters)
    this.options = {
      license_types: {
        loading: false,
        list: LICENSE_TYPES_OPTIONS
      },
      tenants: {
        loading: false,
        list: TENANT_OPTIONS
      }
    }
  }

  getApiData() {
    return {
      [FILTERS_ARGS.LICENSE_TYPE]: this.filters.license_type,
      [FILTERS_ARGS.TENANT]: this.filters.tenant,
    }
  }
}
